import React, { useEffect, useState } from "react";
import Aos from "aos";
import styled from "styled-components";
import { AiOutlineCloseCircle } from "react-icons/ai";

const ChatPopup = () => {
  const [popupLoad, setPopupLoad] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setPopupLoad(false);
    }, 3000);
  }, []);
  useEffect(() => {
    Aos.init({ duration: 1200 });
  }, []);
  return (
    <div>
      {popupLoad === true ? (
        <ChatBotDefault data-aos="fade-up-left">
          Hi, I am <span>MoneyBot</span> I can resolve
          <br /> all queries of <span>Money Manager</span>
          <AiOutlineCloseCircle
            onClick={() => setPopupLoad(false)}
            className="closeIco"
          />
        </ChatBotDefault>
      ) : null}
    </div>
  );
};

export default ChatPopup;

const ChatBotDefault = styled.div`
  position: fixed;
  top: 80%;
  right: 3.5%;
  background-color: rgb(58, 170, 53);
  color: rgb(32, 32, 79);
  color: #fff;
  font-weight: 500;
  padding: 10px 15px;
  z-index: 1000;
  border-radius: 6px;

  span {
    text-decoration: underline;
  }

  .closeIco {
    position: absolute;
    top: -11%;
    right: -3.7%;
    background-color: rgb(58, 170, 53);
    border-radius: 50%;
    font-size: 22px;
    font-weight: 500;
    cursor: pointer;
  }
`;
